import * as wjcCore from '@mescius/wijmo';
import * as wjcGrid from '@mescius/wijmo.grid';

'use strict';

import {ViewChild, Component, OnInit} from '@angular/core';
import {Store} from "@ngrx/store";

import {ToasterService} from "angular2-toaster";

import {ActivePromotionConfig} from "../config/active-promotion.config";
import {DataService, OrientDBCollectionView} from "@cosbeni/database";

@Component({
    standalone: false,
    selector: 'cj-admin-master',
    templateUrl: 'master-management.component.html',
})

export class MasterManagementComponent implements OnInit {
    readonly: Boolean = true;
    @ViewChild('masterGrid') masterGrid: wjcGrid.FlexGrid;
    masters: OrientDBCollectionView;
    vertexes: any[] = [];

    constructor(public store: Store<any>, public dataService: DataService, public toasterService: ToasterService) {
        this.masters = new OrientDBCollectionView(dataService, ActivePromotionConfig.DATABASE, "SELECT FROM DA_Master", "DA_Master", "", 0, 100, true, true, false)
        this.masters.url = ActivePromotionConfig.SERVER_URL;
        this.masters.tokenName = ActivePromotionConfig.DATABASE + "_token";
    }

    ngOnInit() {
        this.masters.currentChanged.addHandler(this.onCurrentChanged, this);
        this.masters.filterOnServer = true;
    }

    onCurrentChanged(sender: any, args: wjcCore.EventArgs): void {
    }

    refresh(grid: string): void {
        this[grid].invalidate();
    }

}

